import useFormatCurrencyForItinerary from '@/src/hooks/currency/useFormatCurrencyForItinerary'
import { PriceBreakUpItem } from '@/src/types/fareFamilyInfo'
import TimelinePriceBreakup from './timelinePriceBreakup'

const TimelinePriceBreakupWrapper = ({ priceBreakup }: { priceBreakup: PriceBreakUpItem[] }) => {
    const { formatCurrency } = useFormatCurrencyForItinerary()
    return <TimelinePriceBreakup priceBreakup={priceBreakup} formatCurrency={formatCurrency} />
}

export default TimelinePriceBreakupWrapper
